import React, { Component } from 'react';

const labels = {
  email: 'Email',
  linkedin: 'LinkedIn',
  github: 'Github'
};

class ProfileLinks extends Component {

  constructor(props) {
    super(props);
    this.showText = props.showText;
  }

  // TO-DO: fix background highlighting on images (CSS)
  render() {
    return (
      <nav className="profile-links">
        <a aria-label={labels.email} title={labels.email} target="_blank" rel="noreferrer noopener" href="mailto:me@pliu.dev">
          <img alt={labels.email} src="/icon/fa/solid/envelope-square.svg"/>{this.showText && <span>Email</span>}</a>
        <a aria-label={labels.linkedin} title={labels.linkedin} target="_blank" rel="noreferrer noopener" href="https://www.linkedin.com/in/peterliu8/">
          <img alt={labels.linkedin} src="/icon/fa/brand/linkedin.svg"/>{this.showText && <span>LinkedIn</span>}</a>
        <a aria-label={labels.github} title={labels.github} target="_blank" rel="noreferrer noopener" href="https://github.com/pll33">
          <img alt={labels.github} src="/icon/fa/brand/github-square.svg"/>{this.showText && <span>Github</span>}</a>
      </nav>
    );
  }
}

export default ProfileLinks;



// WEBPACK FOOTER //
// ./src/components/ProfileLinks.js